import { PremiumPackage } from '@project-gd-x/dating-site-contracts/src/gen/gdx/gateway/web/payment/v2/package_pb';
import { computed } from 'vue';

import { PaymentFlow } from '@/components/payment/components/payment-method/helpers/type/type';
import { getPriceAlpha3Formatted } from '@/helpers/number';
import { useCountry } from '@/hooks/use-country/use-country';
import { getPackagePrice } from '@/pages/payment/helpers/package/package';
import { PaymentStatePackage } from '@/pages/payment/store/payment-state';
import { getTextPageModal } from '@/pages/text-page/helpers/text-page/text-page';
import { ExtractClassFields } from '@/type';

type PackageType = 'premium' | 'credits' | 'default';

type UseSelfArg = {
  paymentFlow: PaymentFlow;
  pkg: PaymentStatePackage;
  isAuthorizeCardToken: boolean;
};

export function useSelf(arg: UseSelfArg) {
  // Ref -----------------------------------------------------------------------
  const textPageModal = getTextPageModal();

  // Hook ----------------------------------------------------------------------
  const country = useCountry();

  // Computed ------------------------------------------------------------------
  const packageType = computed<PackageType>(() => {
    if (arg.pkg.id.includes('premium')) {
      return 'premium';
    }

    if (arg.pkg.id.includes('credits')) {
      return 'credits';
    }

    return 'default';
  });

  const pkgNext = computed<ExtractClassFields<PremiumPackage> | null>(() => {
    if ((arg.pkg as ExtractClassFields<PremiumPackage>).nextPackage) {
      return (arg.pkg as ExtractClassFields<PremiumPackage>).nextPackage ?? null;
    }

    return null;
  });

  // Method --------------------------------------------------------------------
  function getPriceFormatted(pkg: PaymentStatePackage): string {
    if (pkg.id) {
      const price = getPackagePrice(pkg);

      return arg.isAuthorizeCardToken
        ? getPriceAlpha3Formatted(1, price.currency)
        : getPriceAlpha3Formatted(price.totalAmount, price.currency);
    } else {
      return '';
    }
  }

  async function init() {
    await country.load();
  }

  return {
    textPageModal,
    country: country.country,
    packageType,
    pkgNext,
    getPriceFormatted,
    init,
  };
}
